export const typography = {
  fontFamily: 'Manrope Variable, Arial, sans-serif',
  h1: {
    fontFamily: 'Manrope Variable, Arial, sans-serif',
    fontSize: 30,
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: 'Manrope Variable, Arial, sans-serif',
    fontSize: 24,
    fontWeight: 500,
    lineHeight: 1.4,
  },
  h3: {
    fontFamily: 'Manrope Variable, Arial, sans-serif',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.4,
  },
  button: {
    fontFamily: 'Manrope Variable, Arial, sans-serif',
    fontSize: 18,
    fontWeight: 500,
    lineHeight: 1.4,
    textTransform: 'none' as const,
  },
  body1: {
    fontFamily: 'Manrope Variable, Arial, sans-serif',
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 1.4,
  },
  body2: {
    fontFamily: 'Manrope Variable, Arial, sans-serif',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.5,
  },
  caption: {
    fontFamily: 'Manrope Variable, Arial, sans-serif',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.4,
  },
};
